export function getSiblings(element: HTMLElement): HTMLElement[] {
	return Array.prototype.filter.call(
		element.parentElement.children,
		(child: HTMLElement) => {
			return child !== element;
		}
	);
}
